module.exports = __webpack_public_path__ + "media/application/images/marker-blue-36ea411dc8a66b9389412f8d69c017f2.png";